var $aedcd71db4933ed5$exports = {};
$aedcd71db4933ed5$exports = {
  "calendar": "Kalender",
  "day": "dag",
  "dayPeriod": "a.m./p.m.",
  "endDate": "Sluttdato",
  "era": "tidsalder",
  "hour": "time",
  "minute": "minutt",
  "month": "m\xE5ned",
  "second": "sekund",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Valgt dato: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Valgt omr\xE5de: ".concat(args.startDate, " til ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Valgt tid: ".concat(args.time);
  },
  "startDate": "Startdato",
  "timeZoneName": "tidssone",
  "weekday": "ukedag",
  "year": "\xE5r"
};
export { $aedcd71db4933ed5$exports as default };